export default __webpack_public_path__ + "static/media/logoUniamericaWhite.ce540bbd.svg";